import React from 'react';
import servicebanner from '../../assets/images/services-double-screen.png';
import serviceImage2 from '../../assets/images/music-banner.png';
import DownloadBlock from '../shared/DownloadBlock';

function Service() {
  return (
    <>
      <section className="row_am service_section">
        <div className="anchor" id="services" />
        <div className="container">
          <div className="section_title" data-aos="fade-up" data-aos-duration={1500} data-aos-once>
            <span className="title_badge mb-1">Artificial Intelligence</span>
            <h2>
              <span>AI</span> Powered Stories
            </h2>
          </div>
          <div className="row service_blocks">
            <div className="col-md-6">
              <div className="service_text" data-aos="fade-up" data-aos-duration={1500} data-aos-once>
                <h2>
                  Create <span>Magical Stories</span> with AI
                </h2>
                <p>
                  Turn a simple idea into a fully personalized bedtime adventure in seconds. With our advanced AI, you
                  can create unique fairy tales tailored to your child’s name, interests, age, and mood. Every story is
                  generated just for you
                </p>
                <ul className="listing_block">
                  <li>
                    <div className="icon">
                      <span>
                        <i className="icofont-ui-check" />
                      </span>
                    </div>
                    <div className="text">
                      <h3>Personalized Stories in Seconds</h3>
                      <p>
                        Briefly describe your idea, and the app instantly creates a complete, entertaining story that
                        teaches important values through adventure.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span>
                        <i className="icofont-ui-check" />
                      </span>
                    </div>
                    <div className="text">
                      <h3>Choose Your Image Style</h3>
                      <p>
                        Select from different artistic styles: watercolor, cartoon, or dreamy fantasy. Every story looks
                        beautifully unique.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span>
                        <i className="icofont-ui-check" />
                      </span>
                    </div>
                    <div className="text">
                      <h3>Custom Voice Narration</h3>
                      <p>
                        Choose a voice over from multiple soothing or playful options. You can also record your own
                        voice for a personal touch.
                      </p>
                    </div>
                  </li>
                </ul>

                <DownloadBlock section="services_story_types" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="img centered_img" data-aos="fade-up" data-aos-duration={1500} data-aos-once>
                <img src={servicebanner} alt="image" className="service_img_full" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="row_am service_section">
        <div className="anchor" id="music" />
        <div className="container">
          <div className="section_title" data-aos="fade-up" data-aos-duration={1500} data-aos-once>
            <span className="title_badge mb-1">Music</span>
            <h2>
              <span>Custom Music</span> & Songs
            </h2>
          </div>
          <div className="row service_blocks flex-row-reverse">
            <div className="col-md-6">
              <div className="service_text right_side" data-aos="fade-up" data-aos-duration={1500} data-aos-once>
                <h2>
                  Create <span>Custom Music</span> & Songs
                </h2>
                <p>
                  Generate personalized songs and lullabies with original lyrics. Choose from different genres, styles,
                  and customizations — from gentle lullabies to playful nursery tunes. Every song is crafted just for
                  your child.
                </p>
                <ul className="listing_block">
                  <li>
                    <div className="icon">
                      <span>
                        <i className="icofont-ui-check" />
                      </span>
                    </div>
                    <div className="text">
                      <h3>Create Personal AI Music</h3>
                      <p>
                        Turn your idea into an original song in seconds — choose mood, style, and theme, and the AI adds
                        lyrics and vocals.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span>
                        <i className="icofont-ui-check" />
                      </span>
                    </div>
                    <div className="text">
                      <h3>Multiple Music Genres</h3>
                      <p>
                        From gentle lullabies to playful nursery tunes — choose a style that fits your child's mood.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span>
                        <i className="icofont-ui-check" />
                      </span>
                    </div>
                    <div className="text">
                      <h3>Full Customization</h3>
                      <p>Pick tempo, instruments, and vocal style so every track feels personal for your child.</p>
                    </div>
                  </li>
                </ul>
                <DownloadBlock section="services_music" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="img centered_img" data-aos="fade-up" data-aos-duration={1500} data-aos-once>
                <img src={serviceImage2} alt="image" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <div className="row service_blocks">
            <div className="col-md-6">
              <div className="service_text" data-aos="fade-up" data-aos-duration={1500} data-aos-once>
                <h2>
                  Narrate, <span>Collaborate</span>, Elevate, Share
                </h2>
                <p>
                  At FairyTaler, storytelling is a team sport. Connect with friends, family, and dreamers. Collaborate
                  on characters, plot twists, and storylines to create unforgettable tales together.
                </p>
                <ul className="feature_list">
                  <li>
                    <div className="icon">
                      <span>
                        <i className="icofont-check-circled" />
                      </span>
                    </div>
                    <div className="text">
                      <p>Collaborative Storytelling</p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span>
                        <i className="icofont-check-circled" />
                      </span>
                    </div>
                    <div className="text">
                      <p>Easy Sharing</p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <span>
                        <i className="icofont-check-circled" />
                      </span>
                    </div>
                    <div className="text">
                      <p>Elevate Your Stories</p>
                    </div>
                  </li>
                </ul>
                <DownloadBlock />
              </div>
            </div>
            <div className="col-md-6">
              <div className="img centered_img" data-aos="fade-up" data-aos-duration={1500} data-aos-once>
                <img src={serviceImage3} alt="image" />
              </div>
            </div>
          </div> */}
    </>
  );
}

export default Service;
